export default function Git_Best_Practices() {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-4">Git Best Practices</h1>

      <p className="mt-4 text-gray-500 text-sm">Path: /git/best-practices</p>
    </div>
  );
}
